import * as React from "react";
import { FieldProps } from "formik";
import { Form } from "antd";

const FormItem = Form.Item;

export const CheckboxField: React.FC<
  FieldProps<any> & {
    prefix: React.ReactNode;
    label?: string;
    className?: string;
    checkboxClassName?: string;
    disabled?: boolean;
  }
> = ({
  field: { onChange, ...field },
  form: { touched, errors, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  className = "text-white",
  checkboxClassName = "",
  disabled = false,
  ...props
}) => {
    const errorMsg = touched[field.name] && errors[field.name];

    const handleChange = (e: any) => {
      if (disabled) return;
      setFieldValue(field.name, e.target.checked);
    };

    return (
      <FormItem
        help={
          errorMsg ? (
            <div style={{ textAlign: "center" }} className="text-red-500 text-sm mt-1">
                {typeof errorMsg === "string"
                ? errorMsg
                : Array.isArray(errorMsg)
                ? errorMsg.join(", ")
                : null}
            </div>
          ) : null
        }
        validateStatus={errorMsg ? "error" : undefined}
      >
        <div className="w-full flex justify-center mt-8">
          <div className={className}>
            <label className="switch">
              <input
                type="checkbox"
                {...field}
                checked={field.value}
                onChange={handleChange}
                disabled={disabled}
                className={checkboxClassName}
              />
              <span className="slider"></span>
              {label && (
                <span className="ml-3 text-[#CECECF] text-[15px]">{label}</span>
              )}
            </label>
            
          </div>
        </div>
      </FormItem>
    );
  };